import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import { toast } from 'react-toastify';
import Loading from '../../../../components/loading';
import ListPage from '../../../../components/moduleBuilder/ListPage';
import violationIcon from '../../../../icons/violation.png';
import { getApiBaseUrl } from '../../../../constants/apiEnv';
import Forbidden from '../../../Forbidden';

 const Violations=() => {
    const baseURL = getApiBaseUrl() ? getApiBaseUrl() : 'https://api.us.aerosimple.com/api';
    const jwtToken = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      Authorization: jwtToken
    };
    const profile = useSelector(state => state.auth.profile);
    const tableHeadders = [
      ['created_at', 'Date'],
      ['first_name', 'First Name'],
      ['last_name', 'Last Name'],
      ['violation_type', 'Type'],
      ['type', 'Category'],
      ['violation_details', 'Description'],
      ['badge_no', `${profile.permit_management?.badge || 'Badge'} Number`],
      ['points', 'Points']
    ];
    const [loader, setLoader] = useState(false);
    const [logData, setLogData] = useState(undefined);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [totalRecords, setTotalRecords] =useState(0);

    const runLogDataAPI = () => {
      setLoader(true);
      Axios.get(`${baseURL}/app/violations/driver_permit/${profile.current_tenant?.id}/violations_log/?page=${page}&search=${search}`, { headers })
      .then((res) => {
          setLogData(res.data?.violations|| []);
          setLoader(false);
          setTotalRecords(res.data?.count||0);
                  })
      .catch(() => {
        setLoader(false);
        toast.error('Please try again later');
      });
    };

    const onSubmitSearch = (value) => {
       setPage(1);
       setSearch(value);
    };

    useEffect(() => {
        runLogDataAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, search]);

    useEffect(() => {
      if (!logData && profile) {
        runLogDataAPI();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    return (
      <>
        <Loading loadingStatus={loader} />
        {profile?.permissions?.driver_permit?.includes('view_driverpermit')
        ? <ListPage
          tableHeadders={tableHeadders}
          icon={violationIcon}
          logData={logData}
          sectionHeader={{ default: profile?.permit_management?.violations || 'Violations', id: ' ' }}
          tabTitle={{ default: `${profile?.permit_management?.violations || 'Violations'} (${totalRecords})`, id: ' ' }}
          totalRecords={totalRecords}
          onSubmitSearch={onSubmitSearch}
          setPage={setPage}
          page={page}
          route={'/adp/violations'}
          searchEnable
          forViolations
          summary={false}
        />
        : <>
            <Forbidden />
          </>
        }
      </>
    );
};

export default Violations;
